import React from 'react';
import { Col } from 'reactstrap';
import DynamicInput from '../common/DynamicInput';
import IconInputSwitch from './IconInputSwitch';

const IconInput = ({ label, value, type, options, onChange, text, iconKey, minRange="0", maxRange="1", rangeStep="0.01", readOnly=false, md, xl}) => {
    switch(type){
        case 'image':
        case 'editor':
        case 'sendDays':
        case 'skipDays':
        case 'breaks':
            md = md || 12
            xl = xl || 12
            break;
        case 'link':
        case 'text': 
        case 'email': 
        case 'range': 
            md = md || 12
            xl = xl || 6
            break;
        case 'date':
        case 'datetime-local': 
        case 'password': 
            md = md || 6
            xl = xl || 4
            break;
        default:
            md = md || 12
            xl = xl || 12
    }

    const commonProps = { label, value, type, options, onChange, minRange, maxRange, rangeStep, readOnly};

    if(type === 'iconSelect' || type === 'elementSelect' || type === 'userSelect' || type === 'checkbox'){
        return (
            <Col className="align-items-center">
                <DynamicInput {...commonProps}/>
            </Col>
        );
    }
    if(type === 'image'){
        return (
            <Col md="12" className="d-flex align-items-center">
                <DynamicInput {...commonProps}/>
            </Col>
        );
    }
    if(type === 'link'){
        return (
            <Col md={md} xl={xl} className="d-flex align-items-center pl-2">
                <DynamicInput {...commonProps} icon={iconKey}/>
            </Col>
        );
    }
    return (<IconInputSwitch label={label} text={text} iconKey={iconKey} md={md} xl={xl}>
                <DynamicInput {...commonProps}/>
            </IconInputSwitch>
    )};

export default IconInput;

